const LEGACY_AGGREGATOR_ID = "odos"
const REPLACEMENT_AGGREGATOR_ID = "kyber"
const ENABLED_PREFIX = "swap-aggregator-enabled-"
const FALLBACK_AGGREGATOR_KEY = "swap-fallback-aggregator-id"

/**
 * Migrate persisted aggregator settings from Odos to Kyber.
 * Must run before SwapAggregatorStore constructors read localStorage.
 */
export const migrateLegacyAggregatorIds = (): void => {
  if (typeof localStorage === "undefined") {
    return
  }

  const legacyEnabledKey = `${ENABLED_PREFIX}${LEGACY_AGGREGATOR_ID}`
  const replacementEnabledKey = `${ENABLED_PREFIX}${REPLACEMENT_AGGREGATOR_ID}`
  const legacyEnabledValue = localStorage.getItem(legacyEnabledKey)

  if (legacyEnabledValue !== null && localStorage.getItem(replacementEnabledKey) === null) {
    localStorage.setItem(replacementEnabledKey, legacyEnabledValue)
  }

  const savedFallbackId = localStorage.getItem(FALLBACK_AGGREGATOR_KEY)
  if (savedFallbackId === LEGACY_AGGREGATOR_ID) {
    localStorage.setItem(FALLBACK_AGGREGATOR_KEY, REPLACEMENT_AGGREGATOR_ID)
  }
}
